import React, { Component } from "react";
import {
    message,
    PageHeader,
    Spin,
    Row,
    Col,
    Divider,
    Select,
    Form as FormInitial,
    Card,
    Typography,
    Progress,
    Tooltip,
    Alert
} from "antd";
import {
    Form,
    FormItem,
    InputNumberItem,
    SelectItem,
    ButtonItem,
    ErrorItem,
    round10Decimals,
    NotificacionMovimientosInventario,
} from "../../../../Components/Items";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import ElegirMarbetes from "../../Marbetes/ElegirMarbetes/ElegirMarbetes";
import ElegirLotes from "../../LotesCaducidades/ElegirLotes/ElegirLotes";
import ElegirAgrupaciones from "../../Agrupaciones/ElegirAgrupaciones/ElegirAgrupaciones";
import ModalResumenRegularizacion from "./ModalResumenRegularizacion/ModalResumenRegularizacion";
import { CalculatorOutlined, InfoCircleOutlined } from "@ant-design/icons";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import * as XLSX from "xlsx";
pdfMake.vfs = pdfFonts.pdfMake.vfs;


const { Option } = Select;
const { Title, Paragraph } = Typography;


moment.locale("es");

const MAXIMO_INSUMOS_REGULARIZAR = 30;

class RegularizarInventarioVentas extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        datosVenta: undefined,
        todasInsumos: null,
        objetoInsumos: null,
        todasProyectos: null,
        objetoProyectos: null,
        ventasARegularizar: [],
        progressVisible: false,
        progressPercent: 0,
        progressTotalSec: 0,
        regularizarInventarioVentasAbajo: false,
        modalResumen: false,
        resumenRegularizacion: null,
        empresaResumen: null,
        movimientosIdsResumen: null,
    };

    progressInterval = null;
    progressStartTs = null;

    componentWillUnmount() {
        if (this.progressInterval) clearInterval(this.progressInterval);
    }

    componentDidMount() {
        this.consultarTodo();
    }

    async consultarTodo() {
        this.setState({ loading: true });
        await axios
            .post(
                "proyectos/selectTodosProyectos",
                { empresaId: this.props.empresaId },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.status === 404) {
                } else {
                    this.setState({
                        todasProyectos: res.data,
                        objetoProyectos: res.data.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                    });
                }
            });
        await axios
            .post(
                "regularizarInventario/datosRegularizarInventario",
                {
                    empresaId: this.props.empresaId,
                },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        todasInsumos: res.data.insumos,
                        objetoInsumos: res.data.insumos.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.stringBuscar}
                                </Option>
                            );
                        }),
                        ventasARegularizarIds: res.data.ventasARegularizarIds,
                        regularizarInventarioVentasAbajo: res.data.regularizarInventarioVentasAbajo
                    });
                    this.formRef.current.setFieldsValue({
                        insumosRegularizar: res.data.insumosRegularizar
                    });
                } else {
                    message.error(
                        "Error no se encontro informacion de la venta"
                    );
                }
            });
        this.setState({ loading: false });
    }
    onFinishFailed(e) {
        ErrorItem(e);
    }

    sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    startProgress = (totalSec) => {
        if (this.progressInterval) clearInterval(this.progressInterval);

        const totalMs = Math.max(0, Number(totalSec || 0) * 1000);
        this.progressStartTs = Date.now();

        this.setState({
            progressVisible: totalMs > 0,
            progressPercent: totalMs > 0 ? 0 : 100,
            progressTotalSec: totalSec || 0,
        });

        if (totalMs <= 0) return;

        this.progressInterval = setInterval(() => {
            const elapsed = Date.now() - this.progressStartTs;
            const raw = (elapsed / totalMs) * 100;

            // no llegar a 100 hasta que todo termine
            const percent = Math.min(99, Math.max(0, Math.floor(raw)));

            this.setState({ progressPercent: percent });

            if (elapsed >= totalMs) {
                clearInterval(this.progressInterval);
                this.progressInterval = null;
                // dejamos 99% esperando el request si falta
                this.setState({ progressPercent: 99 });
            }
        }, 120);
    };

    stopProgress = () => {
        if (this.progressInterval) clearInterval(this.progressInterval);
        this.progressInterval = null;
        this.progressStartTs = null;

        this.setState({
            progressVisible: false,
            progressPercent: 0,
            progressTotalSec: 0,
        });
    };


    async onFinish(values) {
        let inventarioTodos = 0;
        let inventarioIgual0 = false;
        let insumosConInventarioCapturado = 0;

        // Normaliza + valida
        values.insumosRegularizar = (values.insumosRegularizar || []).map((value) => {
            const inventario = value.inventario; // puede ser 0
            inventarioTodos += Number(inventario || 0);
            if (inventario === 0) inventarioIgual0 = true;
            if(inventario && inventario > 0){
                insumosConInventarioCapturado++;
            }
            return { ...value, inventario };
        });

        if (insumosConInventarioCapturado > MAXIMO_INSUMOS_REGULARIZAR) {
            return message.info(`No puedes regularizar más de ${MAXIMO_INSUMOS_REGULARIZAR} insumos a la vez. Por favor divide tu regularización en partes más pequeñas.`);
        }

        if (inventarioTodos === 0 && !inventarioIgual0) {
            return message.info("Se neceitan cantidades para poder hacer esta operación");
        }

        // 1) ventas
        const ventasLen = (this.state.ventasARegularizarIds || []).length;

        // 2) insumos con inventario CAPTURADO (incluye 0)
        //    Considera "capturado" cuando NO es null/undefined/"" (0 cuenta)
        const insumosCapturadosLen = (values.insumosRegularizar || []).filter((r) =>
            r?.inventario !== undefined && r?.inventario !== null && r?.inventario !== ""
        ).length;

        // 3) mínimo 5s + 1s por cada venta O por cada insumo capturado (el mayor de ambos)
        const items = Math.min(ventasLen, insumosCapturadosLen);
        const totalSec = Math.max(7, 5 + (items * 3)); // siempre >= 5
        const totalMs = totalSec * 1000;

        this.startProgress(totalSec);
        this.setState({ loading: true });

        // Simulación de avance (NO bloquea el submit)
        const delayPromise = this.sleep(totalMs);

        try {
            const requestPromise = axios.post(
                "regularizarInventario/regularizarInventarioVenta",
                {
                    ...values,
                    empresaId: this.props.empresaId,
                    ventasARegularizarIds: this.state.ventasARegularizarIds,
                },
                { headers: this.props.headersToken }
            );

            const first = await Promise.race([requestPromise, delayPromise]);

            let res;
            if (first && first.data) {
                // terminó request primero
                res = first;
            } else {
                // terminó delay primero, mantenemos 99% esperando request
                this.setState({ progressPercent: 99 });
                res = await requestPromise;
            }

            // ✅ request terminó: barra a 100 y se acaba
            this.setState({ progressPercent: 100 });

            if (res.data.success === 2) {
                const ventasConError = res.data.resumen?.totales?.ventasConError || 0;
                if (ventasConError > 0) {
                    message.warning(
                        `Se regularizo el inventario, pero ${ventasConError} ${ventasConError === 1 ? "venta quedo" : "ventas quedaron"} sin entregar. Revisa el resumen.`,
                        8
                    );
                } else {
                    message.success("Se han regularizado los insumos correctamente");
                }
                if (res.data.resumen) {
                    // El PDF de movimientos se dispara al cerrar el resumen: si se llama
                    // aqui, su modal global se queda reintentando detras de este.
                    this.setState({
                        modalResumen: true,
                        resumenRegularizacion: res.data.resumen,
                        empresaResumen: res.data.empresa,
                        movimientosIdsResumen: res.data.movimientosIds,
                    });
                } else {
                    // El backend no pudo armar el resumen: la regularizacion si se hizo.
                    NotificacionMovimientosInventario(res.data.movimientosIds);
                    this.atras();
                }
            } else if (res.data.success === 1) {
                message.error(res.data.message ? res.data.message : "No se pueden regularizar los insumos");
            } else {
                message.error("Hubo un error y no se regularizaron los insumos");
            }
        } catch (err) {
            message.error("Hubo un error al regularizar los insumos");
        } finally {
            this.setState({ loading: false });
            setTimeout(() => this.stopProgress(), 250);
        }
    }


    atras() {
        this.props.history.goBack();
    }
    cerrarModalResumen() {
        const movimientosIds = this.state.movimientosIdsResumen;
        this.setState({
            modalResumen: false,
            resumenRegularizacion: null,
            empresaResumen: null,
            movimientosIdsResumen: null,
        });
        NotificacionMovimientosInventario(movimientosIds);
        this.atras();
    }
    abrirElegirMarbetes(value, marbetes, insumoId, proyectoId) {
        if (proyectoId) {
            this.setState({
                modalElegirMarbetes: true,
                modalElegirMarbetesIndex: value,
                modalElegirMarbetesMarbetes: marbetes || [],
                modalElegirMarbetesInsumoId: insumoId,
                modalElegirMarbetesProyectoId: proyectoId
            })
        } else {
            message.warning('Elegir un proyecto para elegir marbetes')
        }
    }
    cerrarElegirMarbetes(value) {
        const insumos = this.formRef.current.getFieldValue('insumosRegularizar')
        insumos[this.state.modalElegirMarbetesIndex].marbetes = value
        this.formRef.current.setFieldsValue({
            insumosRegularizar: insumos
        })
        this.setState({
            modalElegirMarbetes: false,
            modalElegirMarbetesIndex: null,
            modalElegirMarbetesMarbetes: null,
            modalElegirMarbetesInsumoId: null,
            modalElegirMarbetesProyectoId: null
        })
    }
    abrirElegirLotes(value, lotes, insumoId, proyectoId, cantidad) {
        const clienteId = this.formRef.current.getFieldValue('clienteId')
        if (proyectoId) {
            this.setState({
                modalElegirLotes: true,
                modalElegirLotesIndex: value,
                modalElegirLotesLotes: lotes || [],
                modalElegirLotesInsumoId: insumoId,
                modalElegirLotesProyectoId: proyectoId,
                modalElegirLotesClienteId: clienteId,
                modalElegirLotesCantidad: cantidad
            })
        } else {
            message.warning('Elegir un proyecto para elegir lotes')
        }
    }
    cerrarElegirLotes(value) {
        const insumos = this.formRef.current.getFieldValue('insumosRegularizar')
        insumos[this.state.modalElegirLotesIndex].lotes = value
        this.formRef.current.setFieldsValue({
            insumosRegularizar: insumos
        })
        this.setState({
            modalElegirLotes: false,
            modalElegirLotesIndex: null,
            modalElegirLotesLotes: null,
            modalElegirLotesInsumoId: null,
            modalElegirLotesProyectoId: null,
            modalElegirLotesClienteId: null,
            modalElegirLotesCantidad: null
        })
    }
    abrirElegirAgrupaciones(value, agrupaciones, insumoId, proyectoId) {
        const clienteId = this.formRef.current.getFieldValue('clienteId')
        if (proyectoId) {
            this.setState({
                modalElegirAgrupaciones: true,
                modalElegirAgrupacionesIndex: value,
                modalElegirAgrupacionesAgrupaciones: agrupaciones || [],
                modalElegirAgrupacionesInsumoId: insumoId,
                modalElegirAgrupacionesProyectoId: proyectoId,
                modalElegirAgrupacionesClienteId: clienteId
            })
        } else {
            message.warning('Elegir un proyecto para elegir agrupaciones')
        }
    }
    cerrarElegirAgrupaciones(value) {
        const insumos = this.formRef.current.getFieldValue('insumosRegularizar')
        insumos[this.state.modalElegirAgrupacionesIndex].agrupaciones = value
        this.formRef.current.setFieldsValue({
            insumosRegularizar: insumos
        })
        this.setState({
            modalElegirAgrupaciones: false,
            modalElegirAgrupacionesIndex: null,
            modalElegirAgrupacionesAgrupaciones: null,
            modalElegirAgrupacionesInsumoId: null,
            modalElegirAgrupacionesProyectoId: null,
            modalElegirAgrupacionesClienteId: null
        })
    }
    getReporteConteoData = () => {
        const insumos = (this.formRef.current?.getFieldValue("insumosRegularizar") || []);

        const proyectosMap = new Map((this.state.todasProyectos || []).map(p => [p._id, p]));
        const insumosMap = new Map((this.state.todasInsumos || []).map(i => [i._id, i]));

        // Agrupar por proyectoId
        const grupos = new Map();
        for (const r of insumos) {
            const pid = r.proyectoId || "SIN_PROYECTO";
            if (!grupos.has(pid)) grupos.set(pid, []);

            const ins = insumosMap.get(r.insumoId);

            grupos.get(pid).push({
                clave: ins?.clave || ins?.codigo || ins?.sku || "—",
                codigoBarras: ins?.codigoBarras || ins?.barcode || ins?.codigoDeBarras || "—",

                descripcion: ins?.descripcion || "—",
                proyecto: proyectosMap.get(pid)?.nombre || (pid === "SIN_PROYECTO" ? "Sin proyecto" : "—"),
                cantidadProyecto: r.cantidadProyecto ?? "",
                piezasVendidas: r.piezasVendidas ?? "",
                piezasEntregadas: r.piezasEntregadas ?? "",
                inventarioFisico: r.inventario ?? "",
            });
        }

        return { grupos, proyectosMap };
    };


    descargarPdfConteo = () => {
        const { grupos } = this.getReporteConteoData();
        if (!grupos || grupos.size === 0) return message.info("No hay insumos para exportar.");

        const fecha = moment().format("LL");
        const content = [
            { text: "Reporte de conteo de insumos por proyecto", style: "title" },
            { text: `Fecha: ${fecha}`, style: "sub" },
            { text: " ", margin: [0, 6] },
        ];

        // ...
        for (const [, rows] of grupos.entries()) {
            const nombreProyecto = rows?.[0]?.proyecto || "—";

            content.push(
                { text: `Proyecto: ${nombreProyecto}`, style: "section" },
                {
                    table: {
                        headerRows: 1,
                        widths: ["auto", "auto", "*", "auto", "auto", "auto", "auto"],
                        body: [
                            ["Clave", "Código de barras", "Insumo", "Cant. Proyecto", "Vendida", "Entregada", "Inventario físico"],
                            ...rows.map(r => ([
                                (r.clave ?? "").toString(),
                                (r.codigoBarras ?? "").toString(),
                                r.descripcion,
                                (r.cantidadProyecto ?? "").toString(),
                                (r.piezasVendidas ?? "").toString(),
                                (r.piezasEntregadas ?? "").toString(),
                                (r.inventarioFisico ?? "").toString(),
                            ])),
                        ],
                    },
                    layout: "lightHorizontalLines",
                    margin: [0, 6, 0, 12],
                }
            );
        }
        // ...


        const docDefinition = {
            pageSize: "A4",
            pageMargins: [28, 24, 28, 28],
            content,
            styles: {
                title: { fontSize: 14, bold: true, margin: [0, 0, 0, 2] },
                sub: { fontSize: 10, color: "#555" },
                section: { fontSize: 11, bold: true, margin: [0, 8, 0, 4] },
            },
            defaultStyle: { fontSize: 9 },
        };

        pdfMake.createPdf(docDefinition).download(`conteo_insumos_${moment().format("YYYY-MM-DD")}.pdf`);
    };

    descargarExcelConteo = () => {
        const { grupos } = this.getReporteConteoData();
        if (!grupos || grupos.size === 0) return message.info("No hay insumos para exportar.");

        const wb = XLSX.utils.book_new();

        // Opcional: hoja resumen (todo junto)
        const resumen = [];
        for (const [, rows] of grupos.entries()) {
            for (const r of rows) resumen.push(r);
        }
        const wsResumen = XLSX.utils.json_to_sheet(resumen.map(r => ({
            Proyecto: r.proyecto,
            Clave: r.clave,
            "Código de barras": r.codigoBarras,
            Insumo: r.descripcion,
            "Cantidad Proyecto": r.cantidadProyecto,
            "Piezas Vendidas": r.piezasVendidas,
            "Piezas Entregadas": r.piezasEntregadas,
            "Inventario físico": r.inventarioFisico,
        })));
        XLSX.utils.book_append_sheet(wb, wsResumen, "Resumen");

        // Hoja por proyecto
        for (const [, rows] of grupos.entries()) {
            const nombre = (rows?.[0]?.proyecto || "Proyecto")
                .toString()
                .replace(/[\\/*?:[\]]/g, "")
                .slice(0, 31) || "Proyecto";

            const ws = XLSX.utils.json_to_sheet(rows.map(r => ({
                Clave: r.clave,
                "Código de barras": r.codigoBarras,
                Insumo: r.descripcion,
                "Cantidad Proyecto": r.cantidadProyecto,
                "Piezas Vendidas": r.piezasVendidas,
                "Piezas Entregadas": r.piezasEntregadas,
                "Inventario físico": r.inventarioFisico,
            })));


            XLSX.utils.book_append_sheet(wb, ws, nombre);
        }

        XLSX.writeFile(wb, `conteo_insumos_${moment().format("YYYY-MM-DD")}.xlsx`);
    };

    setMaxEntregarTodos = () => {
        const form = this.formRef?.current; // ajusta si tu ref se llama distinto
        if (!form) return;

        const insumosRegularizar = form.getFieldValue("insumosRegularizar") || [];

        let inventarioCambiado = 0;

        const nuevos = insumosRegularizar.map((row, idx) => {
            // const cantidadProyecto = Number(getFieldValue(["insumosRegularizar", arrayKey, "cantidadProyecto"]) || 0);
            // const piezasVendidas = Number(getFieldValue(["insumosRegularizar", arrayKey, "piezasVendidas"]) || 0);
            // const piezasEntregadas = Number(getFieldValue(["insumosRegularizar", arrayKey, "piezasEntregadas"]) || 0);

            // const minPermitido = Math.max(0, round10Decimals(cantidadProyecto - piezasVendidas + piezasEntregadas));

            const cantidadProyecto = Number(row?.cantidadProyecto) || 0;
            const piezasVendidas = Number(row?.piezasVendidas) || 0;
            const piezasEntregadas = Number(row?.piezasEntregadas) || 0;

            const minPermitido = round10Decimals(cantidadProyecto - piezasVendidas + piezasEntregadas);

            if (inventarioCambiado < 50 && minPermitido > 0) {
                inventarioCambiado++;
                return {
                    ...row,
                    inventario: minPermitido > 0 ? minPermitido : undefined,
                };
            } else {
                return row;
            }

        });

        form.setFieldsValue({ insumosRegularizar: nuevos });
    };

    render() {
        const isMobile = window.innerWidth <= 1000;
        return (
            <>
                <PageHeader
                    onBack={this.atras.bind(this)}
                    title="Regularizar Inventario Ventas"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <h1>
                            Fecha:{" "}
                            {moment(this.state.datosVenta?.createdAt).format("LL")}
                        </h1>
                    }
                />
                <div className="card-background">
                    {this.state.progressVisible && (
                        <div style={{ marginBottom: 12 }}>
                            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                                <span style={{ fontSize: 12, color: "#666" }}>
                                    Procesando.. por favor espera esto puede tardar varios segundos
                                </span>
                            </div>
                            <Progress percent={this.state.progressPercent} status="active" />
                        </div>
                    )}
                    <Spin spinning={this.state.loading}>
                        <Form
                            ref={this.formRef}
                            name="regularizarInventarioVentas"
                            layout
                            bottom={
                                <ButtonItem
                                    type="primary"
                                    htmlType="submit"
                                    style={{ display: "block", margin: "0 0 0 auto" }}
                                >
                                    Regularizar
                                </ButtonItem>
                            }
                            onFinish={this.onFinish.bind(this)}
                            onFinishFailed={this.onFinishFailed}
                        >
                            <Row justify="end" gutter={8} style={{ marginBottom: 10 }}>
                                <Col>
                                    <ButtonItem onClick={this.descargarPdfConteo} type="default">
                                        Descargar PDF
                                    </ButtonItem>
                                </Col>
                                <Col>
                                    <ButtonItem onClick={this.descargarExcelConteo} type="primary">
                                        Descargar Excel
                                    </ButtonItem>
                                </Col>
                            </Row>


                            <Card
                                style={{
                                    marginBottom: 16,
                                    borderRadius: 14,
                                    boxShadow: "0 10px 30px rgba(0,0,0,.06)",
                                    background: "#fafafa",
                                }}
                            >
                                <Title level={4} style={{ marginBottom: 8 }}>
                                    <InfoCircleOutlined style={{ marginRight: 8, color: "#1677ff" }} />
                                    Actualización de Inventario
                                </Title>

                                <Paragraph style={{ marginBottom: 6 }}>
                                    En esta pantalla debes capturar <strong>únicamente la cantidad física real</strong> que tienes en inventario en este momento.
                                </Paragraph>

                                <Paragraph style={{ marginBottom: 6 }}>
                                    <strong>No es necesario considerar ventas ni entregas.</strong>
                                    El sistema se encarga automáticamente de realizar los cálculos.
                                </Paragraph>

                                <Paragraph style={{ marginBottom: 0 }}>
                                    El sistema:
                                    <ul style={{ marginTop: 6 }}>
                                        <li>Suma las unidades que ya fueron vendidas</li>
                                        <li>Resta las unidades necesarias para entregar las ventas</li>
                                        <li>Ajusta el inventario de forma automática</li>
                                    </ul>
                                </Paragraph>

                                <Paragraph style={{ marginTop: 8 }}>
                                    👉 <strong>Solo registra el inventario tal como lo tienes físicamente en este momento.</strong>
                                </Paragraph>
                            </Card>
                            <Alert
                                message="Límite de insumos"
                                description={`Solo se permiten capturar ${MAXIMO_INSUMOS_REGULARIZAR} insumos por regularización.`}
                                type="warning"
                                showIcon
                                style={{ marginBottom: 16 }}
                            />
                            <Divider style={{ marginBottom: 10, marginTop: 5 }} />
                            <FormInitial.List name="insumosRegularizar">
                                {(fields) => (
                                    <>
                                        <div style={{ overflowX: 'auto' }}>
                                            <table className="table" style={{ minWidth: isMobile ? "900px" : "100%" }}>
                                                {fields.length > 0 ? (
                                                    <thead>
                                                        <tr>
                                                            <th className="th-border" style={{ width: "20%" }}>
                                                                Insumo
                                                            </th>
                                                            <th className="th-border" style={{ width: "10%" }}>
                                                                Proyecto
                                                            </th>
                                                            <th className="th-border" style={{ width: "10%" }}>
                                                                Cantidad Proyecto
                                                            </th>
                                                            {!isMobile &&
                                                                <th className="th-border" style={{ width: "10%" }}>
                                                                    Vendido
                                                                </th>}
                                                            {!isMobile &&
                                                                <th className="th-border" style={{ width: "10%" }}>
                                                                    Entregado
                                                                </th>}

                                                            <th className="th-border" style={{ width: "10%" }}>
                                                                Costo
                                                            </th>

                                                            <th className="th-border" style={{ width: "10%" }}>
                                                                Cantidad Real
                                                                <Tooltip title='Poner maximos.'>
                                                                    <CalculatorOutlined onClick={this.setMaxEntregarTodos} style={{ marginLeft: '5px', color: 'green' }} />
                                                                </Tooltip>
                                                            </th>
                                                            <th className="th-border" style={{ width: "10%" }}>
                                                                Accion
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                ) : null}
                                                {fields.map(({ key, name, fieldKey, ...restField }, arrayKey) => (
                                                    <FormItem shouldUpdate noStyle key={fieldKey}>
                                                        {({ getFieldValue }) => {
                                                            const arr = getFieldValue("insumosRegularizar") || [];
                                                            const proyectoId = arr[arrayKey]?.proyectoId;
                                                            const proyectoPrevId = arrayKey > 0 ? arr[arrayKey - 1]?.proyectoId : null;

                                                            const cambioProyecto = arrayKey === 0
                                                                ? !!proyectoId
                                                                : proyectoId && proyectoId !== proyectoPrevId;

                                                            const proyecto = (this.state.todasProyectos || []).find(p => p._id === proyectoId);

                                                            let totalInsumosCapturados = 0;
                                                            for (let i = 0; i < arr.length; i++) {
                                                                if (arr[i]?.inventario !== undefined && arr[i]?.inventario !== null && arr[i]?.inventario !== "") {
                                                                    totalInsumosCapturados++;
                                                                }
                                                            }

                                                            return (
                                                                <tbody key={fieldKey}>
                                                                    {cambioProyecto && (
                                                                        <tr>
                                                                            <td className="td-border" colSpan={7} style={{ padding: 0 }}>
                                                                                <div style={{ marginTop: 10, padding: "10px 12px", background: "#f5f5f5", borderTop: "2px solid #e5e7eb" }}>
                                                                                    <b>Proyecto:</b> {proyecto?.nombre || "—"}
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                    <tr>
                                                                        <td className="td-border">
                                                                            <FormItem
                                                                                {...restField}
                                                                                name={[name, "insumoId"]}
                                                                                fieldKey={[fieldKey, "insumoId"]}
                                                                                required
                                                                                noStyle
                                                                            >
                                                                                <SelectItem
                                                                                    sinBorde
                                                                                    style={{ width: "100%" }}
                                                                                    placeholder="Insumo"
                                                                                    disabled
                                                                                >
                                                                                    {this.state.objetoInsumos}
                                                                                </SelectItem>
                                                                            </FormItem>
                                                                        </td>
                                                                        <td className="td-border">
                                                                            <FormItem
                                                                                {...restField}
                                                                                name={[name, "proyectoId"]}
                                                                                fieldKey={[fieldKey, "proyectoId"]}
                                                                                required
                                                                                noStyle
                                                                            >
                                                                                <SelectItem
                                                                                    disabled
                                                                                    sinBorde
                                                                                    style={{ width: "100%" }}
                                                                                    placeholder="Proyecto"
                                                                                >
                                                                                    {this.state.objetoProyectos}
                                                                                </SelectItem>
                                                                            </FormItem>
                                                                        </td>
                                                                        <td className="td-border">
                                                                            <FormItem
                                                                                {...restField}
                                                                                name={[name, "cantidadProyecto"]}
                                                                                required
                                                                                noStyle
                                                                            >
                                                                                <InputNumberItem
                                                                                    sinBorde
                                                                                    disabled
                                                                                    placeholder="Cantidad en Proyecto"
                                                                                />
                                                                            </FormItem>
                                                                        </td>
                                                                        {!isMobile && <td className="td-border">
                                                                            <FormItem
                                                                                {...restField}
                                                                                name={[name, "piezasVendidas"]}
                                                                                fieldKey={[fieldKey, "piezasVendidas"]}
                                                                                required
                                                                                numberCero
                                                                                noStyle
                                                                            >
                                                                                <InputNumberItem
                                                                                    sinBorde
                                                                                    placeholder="Cantidad Vendida"
                                                                                    disabled
                                                                                />
                                                                            </FormItem>
                                                                        </td>}
                                                                        {!isMobile && <td className="td-border">
                                                                            <FormItem
                                                                                {...restField}
                                                                                name={[name, "piezasEntregadas"]}
                                                                                fieldKey={[fieldKey, "piezasEntregadas"]}
                                                                                required
                                                                                numberCero
                                                                                noStyle
                                                                                initialValue={0}
                                                                            >
                                                                                <InputNumberItem
                                                                                    sinBorde
                                                                                    placeholder="Cantidad Entregada"
                                                                                    disabled
                                                                                />
                                                                            </FormItem>
                                                                        </td>}
                                                                        <td className="td-border">
                                                                            <FormItem
                                                                                {...restField}
                                                                                name={[name, "costo"]}
                                                                                fieldKey={[fieldKey, "costo"]}
                                                                                numberCero
                                                                                noStyle
                                                                                type="number"
                                                                            >
                                                                                <InputNumberItem
                                                                                    sinBorde
                                                                                    placeholder="Costo"
                                                                                />
                                                                            </FormItem>
                                                                        </td>
                                                                        <td className="td-border">
                                                                            <FormItem shouldUpdate noStyle>
                                                                                {({ getFieldValue }) => {
                                                                                    const cantidadProyecto = Number(getFieldValue(["insumosRegularizar", arrayKey, "cantidadProyecto"]) || 0);
                                                                                    const piezasVendidas = Number(getFieldValue(["insumosRegularizar", arrayKey, "piezasVendidas"]) || 0);
                                                                                    const piezasEntregadas = Number(getFieldValue(["insumosRegularizar", arrayKey, "piezasEntregadas"]) || 0);
                                                                                    const inventario = getFieldValue(["insumosRegularizar", arrayKey, "inventario"]);

                                                                                    let minPermitido
                                                                                    let minimoSugerido = Math.max(0, round10Decimals(cantidadProyecto - piezasVendidas + piezasEntregadas));

                                                                                    if (this.state.regularizarInventarioVentasAbajo) {
                                                                                        minPermitido = 0
                                                                                    } else {
                                                                                        minPermitido = Math.max(0, round10Decimals(cantidadProyecto - piezasVendidas + piezasEntregadas));
                                                                                    }


                                                                                    return (
                                                                                        <FormItem
                                                                                            {...restField}
                                                                                            name={[name, "inventario"]}
                                                                                            fieldKey={[fieldKey, "inventario"]}
                                                                                            numberCero
                                                                                            noStyle
                                                                                            type="number"
                                                                                            min={minPermitido}
                                                                                        >
                                                                                            <InputNumberItem
                                                                                                sinBorde
                                                                                                disabled={totalInsumosCapturados >= MAXIMO_INSUMOS_REGULARIZAR && !inventario}
                                                                                                placeholder={"Min: " + minimoSugerido}
                                                                                            />
                                                                                        </FormItem>
                                                                                    );
                                                                                }}
                                                                            </FormItem>
                                                                        </td>
                                                                        <td className="td-border">
                                                                            <Row>
                                                                                <Col span={24}>
                                                                                    <FormItem
                                                                                        noStyle
                                                                                        shouldUpdate
                                                                                    >
                                                                                        {({ getFieldValue }) => {
                                                                                            let arrayValue = getFieldValue("insumosRegularizar");
                                                                                            let mostrarMarbetes = false
                                                                                            let mostrarLotes = false
                                                                                            let mostrarAgrupaciones = false
                                                                                            let insumoId
                                                                                            let proyectoId
                                                                                            if (arrayValue[arrayKey]?.insumoId && this.state.todasInsumos) {
                                                                                                const insumo = this.state.todasInsumos.find(
                                                                                                    (valueInsumos) => valueInsumos._id === arrayValue[arrayKey].insumoId
                                                                                                );
                                                                                                mostrarMarbetes = insumo?.marbetes
                                                                                                mostrarLotes = insumo?.lotesCaducidades
                                                                                                mostrarAgrupaciones = insumo?.agrupaciones
                                                                                                insumoId = insumo?._id
                                                                                                proyectoId = arrayValue[arrayKey]?.proyectoId
                                                                                            }
                                                                                            if (mostrarMarbetes) {
                                                                                                return (
                                                                                                    <ButtonItem
                                                                                                        type="primary"
                                                                                                        size='small'
                                                                                                        style={{ width: '80%', marginLeft: '10%' }}
                                                                                                        block
                                                                                                        onClick={() => {
                                                                                                            this.abrirElegirMarbetes(arrayKey, arrayValue[arrayKey].marbetes, insumoId, proyectoId)
                                                                                                        }}
                                                                                                    >
                                                                                                        Mar.
                                                                                                    </ButtonItem>
                                                                                                )
                                                                                            }
                                                                                            if (mostrarAgrupaciones) {
                                                                                                return (
                                                                                                    <ButtonItem
                                                                                                        type="primary"
                                                                                                        size='small'
                                                                                                        style={{ width: '80%', marginLeft: '10%' }}
                                                                                                        block
                                                                                                        onClick={() => {
                                                                                                            this.abrirElegirAgrupaciones(arrayKey, arrayValue[arrayKey].agrupaciones, insumoId, proyectoId)
                                                                                                        }}
                                                                                                    >
                                                                                                        Agr.
                                                                                                    </ButtonItem>
                                                                                                )
                                                                                            }
                                                                                            if (mostrarLotes) {
                                                                                                return (
                                                                                                    <ButtonItem
                                                                                                        type="primary"
                                                                                                        size='small'
                                                                                                        style={{ width: '80%', marginLeft: '10%' }}
                                                                                                        block
                                                                                                        onClick={() => {
                                                                                                            this.abrirElegirLotes(arrayKey, arrayValue[arrayKey].lotes, insumoId, proyectoId, arrayValue[arrayKey].cantidad)
                                                                                                        }}
                                                                                                    >
                                                                                                        {this.props.taxidermia ? "Animales" : "Lotes"}
                                                                                                    </ButtonItem>
                                                                                                )
                                                                                            }
                                                                                        }}
                                                                                    </FormItem>
                                                                                </Col>
                                                                            </Row>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            )
                                                        }}
                                                    </FormItem>
                                                ))}
                                            </table>
                                        </div>
                                    </>
                                )}
                            </FormInitial.List>
                        </Form>
                    </Spin>
                </div>
                <ElegirMarbetes
                    visible={this.state.modalElegirMarbetes}
                    cerrarElegirMarbetes={this.cerrarElegirMarbetes.bind(this)}
                    marbetes={this.state.modalElegirMarbetesMarbetes}
                    insumoId={this.state.modalElegirMarbetesInsumoId}
                    proyectoId={this.state.modalElegirMarbetesProyectoId}
                />
                <ElegirLotes
                    visible={this.state.modalElegirLotes}
                    cerrarElegirLotes={this.cerrarElegirLotes.bind(this)}
                    lotes={this.state.modalElegirLotesLotes}
                    insumoId={this.state.modalElegirLotesInsumoId}
                    proyectoId={this.state.modalElegirLotesProyectoId}
                    clienteId={this.state.modalElegirLotesClienteId}
                    cantidad={this.state.modalElegirLotesCantidad}
                />
                <ElegirAgrupaciones
                    visible={this.state.modalElegirAgrupaciones}
                    cerrarElegirAgrupaciones={this.cerrarElegirAgrupaciones.bind(this)}
                    agrupaciones={this.state.modalElegirAgrupacionesAgrupaciones}
                    insumoId={this.state.modalElegirAgrupacionesInsumoId}
                    proyectoId={this.state.modalElegirAgrupacionesProyectoId}
                    clienteId={this.state.modalElegirAgrupacionesClienteId}
                />
                <ModalResumenRegularizacion
                    visible={this.state.modalResumen}
                    resumen={this.state.resumenRegularizacion}
                    empresa={this.state.empresaResumen}
                    cerrarModalResumen={this.cerrarModalResumen.bind(this)}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(RegularizarInventarioVentas);
